import React, { Component } from "react";
import {
  API_TOKEN_NAME,
  USER_ID,
  USER_ROLE,
  USER_EMAIL,
  LOGIN_PHONE_NUMBER,
  PATIENT_NAME,
  SEARCH_SELECTED_DOC_ID,
  SEARCH_SELECTED_DOC_NAME,
  SCHEDULE_DATE,
  IMAGE_URL,
  USER_LOCAL_ID,
} from "../../constants";
import { scAxiosAdmin } from "../..";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { startUserSession } from "../../userSession";
import uhlcare_logo from "../../images/uhlcare-logo.webp";
import uhl_logo from "../../images/UHL (2).webp";
import medix_logo from "../../images/medix-logo.webp";
import ma_rashed_logo from "../../images/ma rashed hospital.webp";
import mainlogo from "../../images/main-logo.webp";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
//import doc from '../../images/doc.png';
import $ from "jquery";
import Moment from "moment";
import { MyContext } from "../MyProvider";
import LinkPatientIdPopup from "./LinkPatientIdPopup";

const patientRegistration = (data) => {
  return new Promise((resolve, reject) => {
    const req = scAxiosAdmin.request("/ledger", {
      method: "post",
      headers: {
        Accept: "application/json",
        // Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
      },
      data,
    });
    req.then((res) => resolve(res.data)).catch((err) => reject(err));
  });
};
const alertStyle = {
  color: "red",
};
const input_field_css = {
  maxHeight: "50px",
  fontSize: "14px",
  borderColor: "#cccccc",
  borderRadius: "5px",
};
class PatientRegistrationPopup extends Component {
  static contextType = MyContext;
  state = {
    fields: {},
    errors: {},
    search_doctors: [],
    search_keywords: "",
    doctor_id: "",
    schedule_date: "",
    department_id: "",
    limit: 4,
    search_selected_doc_name: "",
    selectedDate: null,
    payment_type: "",
    privacy_policy: "",
    term_conditions: "",
    showLinkIdPopup: false,
    showPatientRegPopup: "",
  };

  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  handleSubmit = (event, props) => {
    event.preventDefault();

    const type = "patient_registration";
    const user_id = localStorage.getItem(USER_LOCAL_ID);
    const grand_total = 200;
    const total = 200;
    const payment_type = "sslCommerz";
    const status = 1;
    const currency = "BDT";
    const qty = 1;

    const sslCommerz_urls = {
      // null if payment_type is pay_at_uhl
      success_url: `${window.location.origin}/success`,
      fail_url: `${window.location.origin}/fail`,
      cancel_url: `${window.location.origin}/cancel`,
    };
    const data = {
      type,
      user_id,
      grand_total,
      total,
      payment_type,
      sslCommerz_urls,
      status,
      currency,
      qty,
    };

    patientRegistration(data)
      .then((res) => {
        if (res.status === "success") {
          window.location.href = res.data;
        } else {
          toast.error("Something went wrong.Please try again!", {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
        }
      })
      .catch((err) => {
        toast.error("Something went wrong.Please try again!", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      });
  };
  closePopup = (event) => {
    const { DoctorData } = this.context;
    DoctorData({});
    document.getElementById("offcanvasExample5").style.visibility = "hidden";
    document.getElementById("offcanvasExample5").classList.remove("show");
    $(".modal-backdrop.fade.show").remove();
    $("body").css("overflow", "");
    $("body").css("padding-right", "");
  };

  showLinkIdPopup = () => {
    $(".otp_reg").css("visibility", "visible");
    $(".otp_reg").addClass("show");
    $(".modal-backdrop.fade.show").remove();
    $("body").css("overflow", "");
    $("body").css("padding-right", "");
  };
  componentDidMount() {
    if (
      localStorage.getItem(SEARCH_SELECTED_DOC_NAME) &&
      localStorage.getItem(SEARCH_SELECTED_DOC_ID) &&
      localStorage.getItem(SCHEDULE_DATE)
    ) {
      document.getElementById("Schedule").disabled = false;
      document.getElementById("Schedule").style.background = "gray";
    }
    /* if (localStorage.getItem(SEARCH_SELECTED_DOC_NAME)) {
      this.refreshGetSearchDoctors(
        localStorage.getItem(SEARCH_SELECTED_DOC_NAME)
      );
    } */
  }
  render() {
    return (
      <div
        className={`${this.props.showpopup} patientRegister`}
        tabIndex="-1"
        id="offcanvasExample5"
        aria-labelledby="offcanvasExampleLabel5"
        style={{ visibility: "visible" }}
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="offcanvasExampleLabel5">
            {" "}
          </h5>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            onClick={this.closePopup}
          />
        </div>
        <div className="offcanvas-body">
          <div className="row text-center" id="logos">
            <div className="col-2 ">
              <img src={uhlcare_logo} alt="uhlcare-logo" />
            </div>
            <div className="col-2">
              <img src={mainlogo} alt="medix-logo" />
            </div>
            <div className="col-2">
              <img src={uhl_logo} alt="uhl-logo" />
            </div>
            <div className="col-2">
              <img src={medix_logo} alt="medix-logo" />
            </div>

            <div className="col-2">
              <img src={ma_rashed_logo} alt="medix-logo" />
            </div>
          </div>
          <div className="left-offcanvas">
            <h4 style={{ color: "#187979" }}>Patient Registration</h4>
            <form
              onSubmit={this.handleSubmit}
              id="registerform"
              className="needs-validation"
              noValidate
            >
              <div className="row">
                <div className="input-group mt-2">
                  <input
                    disabled
                    type="text"
                    className="form-control"
                    placeholder="Enter Your Full Name "
                    name="fullname"
                    id="fullname"
                    value={localStorage.getItem(PATIENT_NAME) || ""}
                    onChange={this.handleChange}
                    required
                    autoComplete="off"
                    style={input_field_css}
                  />
                </div>
                <span style={alertStyle}>{this.state.errors.fullname}</span>
              </div>

              <div className="row">
                <div className="input-group mt-2">
                  <input
                    disabled
                    type="text"
                    className="form-control PhoneNumber"
                    placeholder="Enter Phone Number"
                    name="phone_number"
                    id="phone_number"
                    value={localStorage.getItem(LOGIN_PHONE_NUMBER) || ""}
                    onChange={this.handleChange}
                    required
                    autoComplete="off"
                    maxLength="11"
                    style={input_field_css}
                  />
                </div>
                <span style={alertStyle}>{this.state.errors.phone_number}</span>
              </div>
              <div className="payment mt-3">
                <div className="row  mb-3">
                  <div className="col-6">
                    <input
                      type="radio"
                      id="payment_type"
                      name="payment_type"
                      className="radio-btn"
                      value="pay_uhl"
                      onChange={this.handleChange}
                    />
                    <label htmlFor="css"> Pay Now</label>
                  </div>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-12">
                  <label className="label-text">
                    <input
                      type="checkbox"
                      name="privacy_policy"
                      id="privacy_policy"
                      value="privacy_policy"
                      onChange={this.handleChange}
                    />{" "}
                    I agree with the Privacy Policy{" "}
                  </label>
                  <br />
                  <label className="label-text">
                    <input
                      type="checkbox"
                      name="term_conditions"
                      id="term_conditions"
                      value="term_conditions"
                      onChange={this.handleChange}
                    />{" "}
                    I agree with the Terms &amp; Conditions
                  </label>
                  <br /> <br />
                </div>
              </div>

              <div className="row mt-2">
                <div className="col-12">
                  <button
                    variant="primary"
                    type="submit"
                    className="btn-links appointment-new submit_btn"
                    id="black-btn"
                  >
                    {" "}
                    Register Now{" "}
                  </button>
                </div>
              </div>
            </form>
            <p>
              <label className="dont">
                Already have a patient ID? <br />
                <button
                  className="nav-link active"
                  onClick={() => this.showLinkIdPopup()}
                  style={{
                    background: "none",
                    border: "none",
                    padding: "0px",
                    color: "rgb(251, 98, 1)",
                  }}
                >
                  Link ID.
                </button>
              </label>
            </p>
          </div>
        </div>

        <LinkPatientIdPopup
        // showPopup={this.state.showPatientRegPopup}
        // userData={user_data}
        // userId={this.state.user_id}
        />
      </div>
    );
  }
}
export default PatientRegistrationPopup;



// WEBPACK FOOTER //
// ./src/component/frontend/PatientRegistrationPopup.js